import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20warm%20gradient%20background%20with%20soft%20overlapping%20circles%20and%20flowing%20shapes%20in%20amber%20and%20cream%20tones%20modern%20minimal%20design%20artistic%20elegant%20smooth%20texture&width=1800&height=900&seq=hero-bg-jiujiu-01&orientation=landscape"
          alt="久久综合聚合平台背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
          海量资源<span className="text-primary-300">一站式</span>聚合平台
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          久久综合汇集影视、音乐、图文、资讯等丰富资源，持续更新，分类清晰，搜索便捷，满足您的全方位内容需求
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/news"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-sm transition-all whitespace-nowrap"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full text-sm transition-all whitespace-nowrap backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>
        <div className="flex items-center justify-center gap-6 mt-10">
          {[
            { num: '12,000+', label: '内容资源' },
            { num: '6', label: '内容分类' },
            { num: '50万+', label: '月活用户' },
            { num: '99.9%', label: '服务可用率' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-white">{stat.num}</div>
              <div className="text-xs text-white/60 mt-0.5">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}